<template lang="pug">
  div.d-flex.justify-content-center
    b-link(to="about-us")
      b-img(:src="alang('section3.about')"  block fluid) 
</template>

<script>
import util from '@/common/lang/util'
export default {
  name: 'Section3Widget',
  mixins: [util],
}
</script>
